/* eslint-disable camelcase */
import getVideosPropertiesLiveStructure from './getVideosPropertiesLiveStructure';
import getVideosPropertiesOnDemandStructure from './getVideosPropertiesOnDemandStructure';

export default ({ adminSettings, data, type }) => {
  const customFieldSchemas = adminSettings.data?.custom_fields?.courses || {};
  const custom_fields = data.data?.custom_fields;

  // custom fields are stored as strings, and booleans are coerced to 't' and 'f'.
  // legacy Rails views coerce them as '1' and '0', so we also check for '1' just in case.
  const customFields = Object.entries(custom_fields).reduce(
    (memo, [key, value]) =>
      customFieldSchemas[key]?.type === 'check_box'
        ? { ...memo, [key]: value === 't' || value === '1' }
        : memo,
    custom_fields,
  );

  const rawData = { ...data.data, customFields };

  const transformedData =
    type === 'on-demand'
      ? getVideosPropertiesOnDemandStructure(rawData)
      : getVideosPropertiesLiveStructure(rawData);
  return transformedData;
};
